import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const LANGS = [
  { code: "en", label: "EN" },
  { code: "pt", label: "PT" },
  { code: "es", label: "ES" },
];

export function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").slice(0, 2);
  const change = (code) => { i18n.changeLanguage(code); };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher"
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-white/10 text-xs uppercase tracking-widest text-white/70 hover:text-white hover:border-white/25 transition-colors"
          aria-label="Change language"
        >
          <Globe size={14} strokeWidth={1.5} />
          {compact ? current.toUpperCase() : (LANGS.find((l) => l.code === current)?.label || "EN")}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#0a0a0a] text-white border-white/10 min-w-[140px]">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => change(l.code)}
            data-testid={`lang-option-${l.code}`}
            className={`cursor-pointer ${current === l.code ? "text-[#00B5D8]" : ""}`}>
            {l.label} {current === l.code ? "· current" : ""}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
